/** Format last-login for user management cards (day + hour:minute, Lisbon when ISO UTC). */
export function formatUserLastLogin(raw: unknown): string {
  if (raw == null || raw === '' || raw === 'Nunca') return 'Nunca';
  const s = String(raw).trim();
  if (!s || s.toLowerCase() === 'nunca') return 'Nunca';

  // Already formatted by backend (e.g. 30-05-2026 14:35)
  if (/^\d{1,2}-\d{1,2}-\d{4} \d{1,2}:\d{2}$/.test(s)) {
    return s;
  }
  if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(s)) {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) return formatDateParts(d);
    return s;
  }

  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return formatDateParts(d);
}

function formatDateParts(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Show field value or em dash when empty. */
export function formatDetailField(value: unknown, fallback = '—'): string {
  if (value == null) return fallback;
  const s = String(value).trim();
  return s || fallback;
}

/** Resolve avatar URL against API origin (CCC app uses main CRM for static uploads). */
export function resolveUserAvatarUrl(
  raw: string | null | undefined,
  apiOrigin: string
): string | undefined {
  if (!raw || typeof raw !== 'string') return undefined;
  if (raw.startsWith('data:image/') || raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw;
  }
  const base = (apiOrigin || '').replace(/\/+$/, '');
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  return base ? `${base}${path}` : path;
}
